export default __webpack_public_path__ + "static/Aviso_Despachos_de_Cobranza_EMG-eaaba13de29c3c1605708a628874b246.pdf";